// User Agent
export const uaString = navigator.userAgent;
export const isAndroid = uaString.indexOf('Android') !== -1;
export const isIOS12 = uaString.indexOf('iPhone OS 12') !== -1;
export const isIOS = uaString.indexOf('iPhone;') !== -1 || uaString.indexOf('iPad;') !== -1;
export const isSafari = isIOS && uaString.indexOf('Safari') !== -1 && uaString.indexOf('Chrome') === -1 && uaString.indexOf('CriOS') === -1 && uaString.indexOf('Android') === -1;
export const is9Or10 = (uaString.indexOf('MSIE 9') !== -1) || (uaString.indexOf('MSIE 10') !== -1);
export const isSmartphonne = isAndroid || isIOS; // スマートフォン判定処理
